import { TagSchema } from "@redotech/redo-common-model/tag";
import * as z from "zod";

export const updateOrderTrackingShipment = {
  name: "updateOrderTrackingShipment" as const,
  input: z.object({
    shipmentId: z.string(),
    tags: z.array(TagSchema).nullish(),
    internalNote: z.string().nullish(),
  }),
  output: z.null(),
};
